export default __webpack_public_path__ + "static/media/bike-insur.54a3033e.jpg";